import * as types from './types';

export const INITIAL_STATE = {
  showLookUp: false,
  showLoading: false,
  searchResults: [],
  message: '',
  hasNext: false,
  query: {
    term: '',
    visitingStudent: false,
  },
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.RESET_LOOKUP:
      return {
        ...INITIAL_STATE,
        message: '',
        query: {
          term: '',
          visitingStudent: state.query.visitingStudent, // keep visiting student toggle selection
        },
      };
    case types.UPDATE_SHOW_LOOKUP_QUERY:
      return {
        ...state,
        query: {
          ...state.query,
          ...payload,
        },
      };
    case types.SHOW_LOOKUP:
      return {
        ...state,
        showLookUp: payload,
      };
    case types.LOOK_SEARCH:
      return {
        ...state,
        searchResults: payload.results,
        message: payload.message,
      };
    case types.LOOKUP_LOADING:
      return {
        ...state,
        showLoading: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/state/reducer.js